import cogoToast from "cogo-toast"
import CardCategory1 from "components/CardCategory1/CardCategory1";
import Heading6 from "components/Heading/Heading6"
import Heading7 from "components/Heading/Heading7"
import Link from "components/Link"
import React, { useState } from "react";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import ViewerScreenContainer from "ViewerScreenContainer"


const WidgetHeaderCategories = ({
  className = "dark:bg-neutral-800",
  categories,
  youtube,
  live,
  posts,
}) => {
  const [hasVideo, setHasVideo] = useState(false);

  const filtered = posts.filter((post) => post.section_id == 6);

  return (
    <div style={{ paddingBottom: "20px" }}
      className={`nc-WidgetCategories overflow-hidden ${className}`}
    >
      <div className="flow-root">

        {hasVideo && (
          <button
            style={{
              fontFamily:'Roboto',
              fontSize:"20px",
              color: !live.length ? "black" : "red"
            }}
            onClick={() => setHasVideo(false)}
          >
            Wyłącz live
          </button>
        )}

        <button
          className="subcategory-btn"
          style={{
            backgroundColor:'red',
            fontSize:"20px",
            color:"white",
            width:"46%",
            border:"none",
            padding:"3px"
          }}
        >
          Bądz na bieżąco
        </button>

        {filtered.slice(0,4).map((post) => (
          <CardCategory1
            className="hover:bg-neutral-200 dark:hover:bg-neutral-700"
            key={post.id}
            id={post.id}
            video={post?.video}
            type={post?.type}
            image={post?.image.replace(".jpg", ".webp")}
            category={post?.name}
            subcategory={post?.title.toLowerCase()}
            category_id={post?.category_id}
            subcategory_id={post?.subcategory_id}
            name={post?.article_title}
            size="normal"
          />
        ))}
         <button
          className="subcategory-btn"
          style={{
            backgroundColor:'red',
            fontSize:"20px",
            color:"white",
            width:"46%",
            border:"none",
            padding:"3px"
          }}
        >
          Na żywo
        </button>
        <div style={{display:"flex", flexFlow:"column", gap:"36px", width:"100%"}}>
           {/* <ViewerScreenContainer
          live={live}
          setHasVideo={setHasVideo}
          hasVideo={hasVideo}
          channelId="UCtHB_yePa8IAK0f14pCQ_lg" // <-- Twój CHANNEL ID
/> */}
   {youtube?.[1]?.youtube_id && (
  <LiteYouTubeEmbed
    key={youtube[1].youtube_id}
    id={youtube[1].youtube_id}
    title="YouTube video"
  />
)}
        </div>
      </div>
    </div>
  );
};

export default WidgetHeaderCategories;